import React from 'react';
import {SkeletonMUI} from '../../../../shared';

const CompaniesSkeleton = ({loading}) => {
  return (
    <div>
      <div className='your-companies__head'>
        <div className='your-companies__head-title'>
          <SkeletonMUI loading={loading} variant={'text'} width={200} height={30} />
        </div>
      </div>
      <div className='your-companies__search'>
        <SkeletonMUI loading={loading} variant={'text'} height={80} />
      </div>
      <div className={`companies-item`}>
        <div className='companies-item__image'>
          <SkeletonMUI loading={loading} variant={'circle'} width={56} height={56} />
        </div>
        <div className='companies-item__info'>
          <div className='companies-item__address'>
            <SkeletonMUI loading={loading} variant={'text'} />
          </div>
          <div className='companies-item__place'>
            <SkeletonMUI loading={loading} variant={'text'} className={'companies-item__place--skeleton'} />
          </div>
          <div className='companies-item__details'>
            <div className='companies-item__rating'>
              <SkeletonMUI loading={loading} variant={'text'} width={20} />
            </div>
            <div className='companies-item__projects'>
              <SkeletonMUI loading={loading} variant={'text'} width={80} />
            </div>
          </div>
        </div>
      </div>
      <div className={`companies-item`}>
        <div className='companies-item__image'>
          <SkeletonMUI loading={loading} variant={'circle'} width={56} height={56} />
        </div>
        <div className='companies-item__info'>
          <div className='companies-item__address'>
            <SkeletonMUI loading={loading} variant={'text'} />
          </div>
          <div className='companies-item__place'>
            <SkeletonMUI loading={loading} variant={'text'} className={'companies-item__place--skeleton'} />
          </div>
          <div className='companies-item__details'>
            <div className='companies-item__rating'>
              <SkeletonMUI loading={loading} variant={'text'} width={20} />
            </div>
            <div className='companies-item__projects'>
              <SkeletonMUI loading={loading} variant={'text'} width={80} />
            </div>
          </div>
        </div>
      </div>
      <div className={`companies-item`}>
        <div className='companies-item__image'>
          <SkeletonMUI loading={loading} variant={'circle'} width={56} height={56} />
        </div>
        <div className='companies-item__info'>
          <div className='companies-item__address'>
            <SkeletonMUI loading={loading} variant={'text'} />
          </div>
          <div className='companies-item__place'>
            <SkeletonMUI loading={loading} variant={'text'} className={'companies-item__place--skeleton'} />
          </div>
          <div className='companies-item__details'>
            <div className='companies-item__rating'>
              <SkeletonMUI loading={loading} variant={'text'} width={20} />
            </div>
            <div className='companies-item__projects'>
              <SkeletonMUI loading={loading} variant={'text'} width={80} />
            </div>
          </div>
        </div>
      </div>
      <div className={`companies-item`}>
        <div className='companies-item__image'>
          <SkeletonMUI loading={loading} variant={'circle'} width={56} height={56} />
        </div>
        <div className='companies-item__info'>
          <div className='companies-item__address'>
            <SkeletonMUI loading={loading} variant={'text'} />
          </div>
          <div className='companies-item__place'>
            <SkeletonMUI loading={loading} variant={'text'} className={'companies-item__place--skeleton'} />
          </div>
          <div className='companies-item__details'>
            <div className='companies-item__rating'>
              <SkeletonMUI loading={loading} variant={'text'} width={20} />
            </div>
            <div className='companies-item__projects'>
              <SkeletonMUI loading={loading} variant={'text'} width={80} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompaniesSkeleton;
